<template>
    <div class="sistema">
        <Header></Header>
        <div class="container">
            <!-- SOBRE -->
            <div class="row mt-5">
                <div class="col-12 col-md-6">
                    <span class="txt-p txt-size-20 txt-roxo-1">
                        Sobre nosso serviço de <span class="txt-w-bold">Orientação Técnica</span>
                    </span>
                    <p class="txt-p txt-cores-1 mt-2">
                        O Sollicita Orientações Técnicas é uma ferramenta de conhecimento aplicado ideal para as dúvidas do dia a dia e também para seus problemas mais complexos. Por meio de respostas objetivas e dos estudos técnicos, analisamos a sua necessidade com todo o suporte e material necessário, resultando em um estudo dirigido que poderá inclusive ser replicado em outras demandas da Entidade. As orientações são de caráter consultivo acompanhadas da melhor e mais profunda fundamentação.
                    </p>
                </div>
                <div class="col-12 col-md-6">
                    <img src="../assets/img/pessoas-circle.png" style="max-width: 100%" />
                </div>
            </div>

            <!-- TIPOS -->
            <div class="row mt-5 justify-content-center">
                <div class="col-6 text-center">
                    <span class="txt-p txt-roxo-1 txt-size-20">
                        Nós possuimos <span class="txt-w-bold txt-size-20">5 tipos</span> de atendimento:
                    </span>
                </div>
            </div>

            <div class="" v-for="(item,index) in tiposAtendi" :key="index">
                <div class="row margin-tipos" v-if="index%2 ==0">
                    <div class="col-12 col-md-6 d-flex flex-column justify-content-center align-items-end">
                        <span class="txt-p txt-size-20 txt-roxo-1 txt-w-bold text-end">{{item.titulo}}</span>
                        <p class="txt-p text-end w-70" v-html="item.descricao"></p>
                    </div>
                    <div class="col-12 col-md-6">
                        <img class="img-tipos" :src="item.img" />
                    </div>
                </div>

                <div class="row margin-tipos" v-else>
                    <div class="col-12 col-md-6 d-flex justify-content-end">
                        <img class="img-tipos" :src="item.img" />

                    </div>
                    <div class="col-12 col-md-6 d-flex flex-column justify-content-center">
                        <span class="txt-p txt-size-20 txt-roxo-1 txt-w-bold text-start">{{item.titulo}}</span>
                        <p class="txt-p text-start w-70" v-html="item.descricao"></p>
                    </div>
                </div>
            </div>

        </div>
        <div class="bg-cinza-curvado">
            <div class="container">
                <!-- ESCOLHA QUANTAS ORIENTACOES -->
                <div class="row justify-content-center">
                    <div class="col-8 text-center">
                        <p class="txt-p txt-size-20 txt-roxo-1 txt-w-5">Escolha quantas orientações você precisar.</p>
                        <p class="txt-p txt-cores-1 txt-w-4">
                            Atentos as diversas necessidades da Administração Pública oferecemos oito pacotes a sua escolha! E acesso ilimitado e irrestrito a nossa plataforma de pesquisa, capacitação e gestão. Uma customização que apenas o Sollicita oferece.
                        </p>
                        <button class="btn btn-roxo px-4" @click="$router.push({ name: 'Planos' })">
                            CONHEÇA NOSSOS PLANOS AGORA!
                        </button>
                    </div>
                </div>

                <!-- TUDO ISSO FEZ -->
                <div class="row align-items-center my-7">
                    <div class="col-12 col-md-6">
                        <img src="../assets/img/caderno-circle.png" style="max-width: 100%" />
                    </div>
                    <div class="col-12 col-md-6">
                        <p class="txt-p txt-size-20 txt-roxo-1 txt-w-5">Tudo isso fez sentido para você?</p>
                        <p class="txt-p txt-cores-1 mb-5">Solicite um contato agora mesmo e ainda ganhe 7 dias para testar o portal de conteúdo e as ferramentas exclusivas que só o Sollicita tem.</p>
                        <button class="btn btn-roxo btn-teste-gratis px-5" @click="$router.push({ name: 'Planos' })">SOLICITAR SENHA CORTESIA</button>
                    </div>
                </div>

                <!-- DIFERENCIAIS -->
                <div class="row justify-content-center my-9 mb-3">
                    <div class="col-12 text-center mb-3">
                        <span class="txt-p txt-size-20 txt-roxo-1 txt-w-5">Quais nossos diferenciais?</span>
                    </div>
                    <div class="col-12 col-md-4">
                        <p>
                            Somente no Sollicita você tem acesso a um mentor especializado de qualquer lugar do país com sistema exclusivo e app; o menor tempo de resposta; exclusivo programa de mentoria e capacitação; acesso às respostas por escritos já publicadas, além do bônus de  poder ter acessos ilimitados as ferramentas de gestão exclusivas do Sollicita.
                        </p>
                    </div>
                    <div class="col-12 col-md-8 ">
                        <div class="row h-">
                            <div class="col-12 col-md-12 ps-2 ps-md-5 d-flex flex-column justify-content-between" v-for="(item,index) in diferenciais" :key="index">
                                <div class="item-diferenciais my-3 txt-p">
                                    {{item}}
                                </div>
                            </div>

                        </div>

                    </div>
                </div>


                <!-- VANTAGENS -->
                <div class="row justify-content-center my-7 mb-3">
                    <div class="col-12 text-center mb-3">
                        <span class="txt-p txt-size-20 txt-roxo-1 txt-w-5">Vantagens</span>
                    </div>
                    <div class="col-12 mt-5 d-flex justify-content-center" v-for="(item,index) in vantagens" :key="index">
                        <div class="item-vantagens">
                            <i class="fas fa-circle txt-size-5 me-2 "></i>
                            <span class="txt-p">{{item}}</span>
                        </div>
                    </div>
                </div>

                
            </div>
        </div>

        <!-- QUEM UTILIZA -->
        <div class="">

            <QuemUtiliza></QuemUtiliza>
        </div>

        <div class="bg-cinza">
            <div class="container ">
                <Noticias></Noticias>

                <Depoimentos class="my-7"></Depoimentos>
            </div>
        </div>



        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Depoimentos from '@/components/Depoimentos'
    import Noticias from '@/components/Noticias'
    import QuemUtiliza from '@/components/QuemUtiliza'

    import tpAtendimento1 from '@/assets/img/tpAtendimento-1.png'
    import tpAtendimento2 from '@/assets/img/tpAtendimento-2.png'
    import tpAtendimento3 from '@/assets/img/tpAtendimento-3.png'
    import tpAtendimento4 from '@/assets/img/tpAtendimento-4.png'
    import tpAtendimento5 from '@/assets/img/tpAtendimento-5.png'

    export default {
        name: 'Sistema',
        components: { Header, Footer, Depoimentos, Noticias, QuemUtiliza },
        data: function () {
            return {
                tpAtendimento1,
                tpAtendimento2,
                tpAtendimento3,
                tpAtendimento4,
                tpAtendimento5,

                tiposAtendi: [
                    { titulo: 'Contato telefônico', img: tpAtendimento1, descricao:'Está com pressa e precisa esclarecimentos pontuais? Por meio de contato telefônico você consegue falar com um mentor. O contato telefônico destina-se à resolução de questões pontuais e urgentes que não podem observar os prazos para respostas por escrito.'},
                    { titulo: 'Respostas Objetivas dentro de 04 horas úteis', img: tpAtendimento2, descricao:'A resposta objetiva, com o entendimento da equipe técnica sobre o tema solicitado, é elaborada de forma sucinta e em tempo mínimo, com fundamentação para atender questionamento pontual da Administração, respondida em até 04 (quatro) horas úteis.'},
                    { titulo: 'Estudos técnicos dentro de 24 horas úteis', img: tpAtendimento3, descricao:'O estudo técnico é a resposta com o entendimento da equipe técnica sobre o tema solicitado, elaborada com fundamentação aprofundada, contendo transcrições, de acordo com a complexidade da matéria e do volume de questionamentos apresentados, respondido em até 24 (vinte e quatro) horas úteis.'},
                    { titulo: 'Atendimento WhatsApp dentro de 02 horas úteis', img: tpAtendimento4, descricao:'O cliente pode pedir a ajuda de um mentor também por whatsapp, diretamente pelo aplicativo ou pelo sistema do Sollicita. E a resposta se dará em áudio, sendo incorporada no sistema para que você escute quantas vezes for necessário.'},
                    { titulo: 'Mentoria online dentro de 48 horas úteis', img: tpAtendimento5, descricao:'A Mentoria online é uma inovação e exclusividade Sollicita, e consiste na prestação de serviços de capacitação interativa em matéria de Licitações e Contratos Administrativos, por meio da exposição dialogada de conteúdo, online e ao vivo, a ser conduzida por um ou mais membros do Corpo Técnico. Será realizada por meio da plataforma zoom, relativamente a temáticas previamente demandadas pelo interessado, a serem pontualmente delimitadas via sistema. Trata-se de auxílio aos gestores e demais servidores atuantes na área de contratações públicas, nos termos adiante especificados.'},
                ],

                diferenciais: [
                    "Contar com o suporte de um mentor especializado, qualificado e experiente em licitações e contratos, em qualquer lugar do país, por meio de telefone, whatsapp e videoconferências, além do sistema exclusivo Sollicita, com o app na palma da mão;",
                    "Ter a garantia da qualidade e tradição da Negócios Públicos, há 20 anos no mercado, aliada ao menor tempo de resposta;",
                    "Ter acesso ao exclusivo programa de Mentoria destinado aos gestores e demais servidores atuantes. A mentoria consiste em uma capacitação interativa em matéria de Licitações e Contratos Administrativos, por meio da exposição dialogada de conteúdo, online e ao vivo, a ser conduzida por um ou mais membros do Corpo Técnico, por meio da plataforma zoom, relativa a temáticas previamente demandadas pelo interessado;",
                ],

                vantagens: [
                    "Segurança e autonomia na tomada de decisões;",
                    "Mais eficiência na gestão e nos processos;",
                    "Maior celeridade e otimização do tempo;",
                    "Capacitação continuada;",
                    "Maior qualidade dos produtos e serviços contratados.",
                ],


            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .margin-tipos{
        margin-top: 6rem;
    }

    .my-7{
        margin: 6rem 0 ;
    }

    .my-9 {
        margin: 9rem 0;
    }
    .bg-cinza {
        background-color: #eeebef;
        padding-top: 6.5rem;
    }

    .bg-cinza-curvado {
        background-image: url(../assets/img/retangulo-curvado-home.png);
        padding-top: 10%;
        /*background-color: #E5E5E5;*/
        background-repeat: no-repeat;
        background-position: top center;
    }

    .item-diferenciais {
        color: #474747;
        padding: 10px 10px 10px 30px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(122, 122, 122, 0.25);
        border-radius: 5px;
        position: relative;
        
    }

    .item-diferenciais::before {
        position: absolute;

        content: "*";
        width: 25px;
        height: 25px;
        background: #732A90;
        border-radius: 50px;

        left: -12px;
        top: 35%;
        color: transparent;
    }

    .img-tipos{
        max-width: 100%;
        max-height: 210px;
    }

    .item-vantagens {
        width: 50%;

        background: #FFFFFF;
        box-shadow: 0px 0px 10px rgba(122, 122, 122, 0.25);
        border-radius: 5px;

        padding: 20px;

        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
    }

    .item-vantagens::before {
        position: absolute;
        content: "+";

        font-size: 80px;

        left: -27px;
        top: -69px;
        color: #5B306C;
    }

    
</style>

